import React from "react";
import { Helmet } from "react-helmet";
import withStyles from "@material-ui/core/styles/withStyles";
import queryString from 'stringquery';
import ReactGA from 'react-ga';

import Header from "../../components/Header/Header.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";

import SectionFeatures from "./Sections/SectionFeatures";

import sectionsPageStyle from "../../assets/jss/material-kit-pro-react/views/sectionsPageStyle";

import { GOOGLE_ADWORDS_KEY } from '../../config/constants';

class ReservationPaymentResultPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            response: {}
        };
    }

    componentDidMount() {
        const response = queryString(this.props.location.search);
        this.setState({ response });

        /*
        TODO: hay que testear si Adwords esta bien configurado
         */
        ReactGA.ga('event', 'conversion', {
            'send_to': `${GOOGLE_ADWORDS_KEY}/rRbsCOX144oBEMG3v54D`,
            'value': response.TX_VALUE,
            'currency': response.currency
        });

        localStorage.removeItem('BOOKING_INFO');
        localStorage.removeItem('SENDED_BOOKING_INFO');
        localStorage.removeItem('PAYMENT_INFO');
        localStorage.removeItem('BOOKING_IDS');
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Transacción finalizada | Vivamos el Campo - Turismo Rural</title>
                    <link rel="canonical" href="https://vivamoselcampo.co/reservation-payment-result" />
                </Helmet>

                <Header
                    fixed
                    brand="Vivamos el Campo Logo"
                    color="dark"
                    links={<HeaderLinks dropdownHoverColor="info"/>}
                />
                <div className={classes.main}>
                    <SectionFeatures response={this.state.response} />
                </div>
            </div>
        );
    }
}

export default withStyles(sectionsPageStyle)(ReservationPaymentResultPage);



// WEBPACK FOOTER //
// ./src/views/ReservationPaymentResultPage/ReservationPaymentResultPage.js